<div class="div-loader {{ animation }}" *ngIf="loader.loading">
  <div class="div-loader-background"></div>
  <div class="div-img">
    <img src="{{ images.loader }}" alt="loader">
  </div>
</div>
